module.exports = "<div class=Form__columns><div v-for=\"column in columns\" class=Form__column><component v-for=\"field in column\" :is=field.type :fdata=field></component></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/containers/columns.vue
// module id = 410
// module chunks = 0